import { render } from "./order-detail.vue?vue&type=template&id=fe8bfbb6&scoped=true"
import script from "./order-detail.vue?vue&type=script&lang=js"
export * from "./order-detail.vue?vue&type=script&lang=js"

import "./order-detail.vue?vue&type=style&index=0&id=fe8bfbb6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fe8bfbb6"]])

export default __exports__